import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import posed, { PoseGroup } from 'react-pose';
import styles from './Notes.module.scss';

const Notes = ({ className, notes }) => {  
  const Fade = posed.div({
    enter: { opacity: 1, transition: { duration: 750 } },
    exit: { opacity: 0 }
  });
  const items = notes.map((note, i) => (
    <Fade key={i} className={styles.note}>
      {note.text && <span id='noteText' dangerouslySetInnerHTML={{__html: note.text}}/>}
      {note.author && <span id='noteAuthor' className={styles.info}>{`${note.author}`}</span>}
      {note.date && <span id='noteDate' className={styles.info}>{`${note.date}`}</span>}
    </Fade>
  ));

  return (
    <div className={classNames(className, styles.container)}>
      <PoseGroup>
        {items}
      </PoseGroup>
    </div>
  )
}

Notes.propTypes = {
  className: PropTypes.string,
  notes: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    author: PropTypes.string,
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })).isRequired,
}

export default Notes
